export default __webpack_public_path__ + "static/media/feeding.cb571bad.png";